const modalCommentStore = {
  state: {
    openComment: null,
    messageComment: '',
    reference: '',
  },
  getters: {
    openComment(state) {
      return state.openComment;
    },
    messageComment(state) {
      return state.messageComment;
    },
    reference(state) {
      return state.reference;
    },
  },
  mutations: {
    OPEN_COMMENT(state) {
      state.openComment = true;
    },
    CLOSE_COMMENT(state) {
      state.openComment = false;
    },
    UPDATE_MESSAGE_COMMENT(state, message) {
      state.messageComment = message;
    },
    UPDATE_REFERENCE_COMMENT(state, reference) {
      state.reference = reference;
    },
  },
};
export default modalCommentStore;
